var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("polygon",{"points":"14,44.5 14,1.2 47.5,22.85 81,44.5 47.5,66.15 14,87.8 \t"})));
}

PlayButton.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 90 90","style":{"enableBackground":"new 0 0 90 90"},"xmlSpace":"preserve"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
